import Config from '../config'
import {authMiddlewareXMLHttp} from '../util/request/middleware'
import url from 'url'

export function upload({fileName, uri, type}, onProgress){
	const xhr = new XMLHttpRequest()

	return {
		cancel: () => {
			xhr.abort()
		},
		promise: new Promise((accept, reject) => {
			xhr.open('POST', url.resolve(Config.MYBUDGETAPI_ENDPOINT, 'v1/file/upload'))
			authMiddlewareXMLHttp(xhr)

			xhr.responseType = 'json'

			xhr.onerror = (e) => {
				reject(e)
			}

			xhr.onreadystatechange = () => {
				const states = [
					'UNSENT',
					'OPENED',
					'HEADERS_RECEIVED',
					'LOADING',
					'DONE'
				]

				console.log('XHR: ', states[xhr.readyState])
			}

			xhr.onload = () => {
				if(xhr.status !== 202 || !xhr.response){
					reject(xhr.response)
				}

				accept(xhr.response)
			}

			if(onProgress){
				xhr.upload.onprogress = onProgress
			}

			const attachment = {
				uri: uri,
				type: type,
				name: fileName
			}

			let data
			if(typeof(FormData) !== 'undefined'){
				data = new FormData()
				data.append('data', attachment)
			}else{
				data = attachment // for tests :(
			}

			xhr.send(data)
		})
	}
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/api/file.js